export enum BubbleTheme {
  DEFAULT = 'default',
  OREO = 'oreo',
  TARO = 'taro',
}

export const BUBBLE_THEME_CLASS_NAMES = {
  [BubbleTheme.DEFAULT]: {
    character: {
      bg: 'bg-gray-sub1',
      text: 'text-white',
      instructionText: 'text-white/50',
    },
    mine: {
      bg: 'bg-primary-300',
      translucentBg: 'bg-gray-sub3',
      text: 'text-white',
      instructionText: 'text-white/50',
    },
  },
  [BubbleTheme.OREO]: {
    character: {
      bg: 'bg-white',
      text: 'text-black',
      instructionText: 'text-[rgba(0,0,0,0.5)]',
    },
    mine: {
      bg: 'bg-[rgba(62,62,65,0.96)]',
      translucentBg: 'bg-[rgba(62,62,65,0.96)]',
      text: 'text-white',
      instructionText: 'text-white/50',
    },
  },
  [BubbleTheme.TARO]: {
    character: {
      bg: 'bg-white',
      text: 'text-black',
      instructionText: 'text-[rgba(0,0,0,0.5)]',
    },
    mine: {
      bg: 'bg-[#DED6FF]',
      translucentBg: 'bg-[#DED6FF]',
      text: 'text-black',
      instructionText: 'text-[rgba(0,0,0,0.5)]',
    },
  },
} as const;
